/**
 * Saved links are often bare ("www.site.com"); unprefixed, an iframe or <a>
 * treats them as paths on this origin and loads the Universe inside itself.
 */
export function normalizeUrl(raw: string | null | undefined): string | null {
  const value = raw?.trim();
  if (!value) return null;
  const withScheme = /^[a-z][a-z\d+.-]*:/i.test(value) ? value : `https://${value.replace(/^\/+/, '')}`;
  try {
    const url = new URL(withScheme);
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null;
  } catch {
    return null;
  }
}

export function siteHost(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

export function faviconUrl(url: string, size = 64): string {
  return `https://www.google.com/s2/favicons?sz=${size}&domain_url=${encodeURIComponent(url)}`;
}

export const SHOT_WIDTH = 1280;
export const SHOT_HEIGHT = 960;

/** WordPress mShots: free, keyless page capture. Serves a placeholder until the capture is ready. */
export function siteShotUrl(url: string, attempt = 0): string {
  const retry = attempt ? `&r=${attempt}` : '';
  return `https://s0.wp.com/mshots/v1/${encodeURIComponent(url)}?w=${SHOT_WIDTH}&h=${SHOT_HEIGHT}${retry}`;
}
